import React from 'react';

function AdvanceDetailsModal() {
  return <div>AdvanceDetailsModal</div>;
}

export default AdvanceDetailsModal;
